import { apiFetch, type ApiResponse } from "./api";
import type { OkResponse, ProfileResponse } from "./types";

export interface FavoriteEntry {
  id: string;
  createdAt: string;
  user: ProfileResponse;
}

export async function listFavorites(): Promise<ApiResponse<FavoriteEntry[]>> {
  return apiFetch<FavoriteEntry[]>("/api/favorites", { method: "GET" });
}

export async function addFavorite(userId: string): Promise<ApiResponse<OkResponse & { userId: string }>> {
  return apiFetch<OkResponse & { userId: string }>("/api/favorites", {
    method: "POST",
    body: JSON.stringify({ userId }),
  });
}

export async function removeFavorite(userId: string): Promise<ApiResponse<OkResponse>> {
  return apiFetch<OkResponse>(`/api/favorites/${encodeURIComponent(userId)}`, {
    method: "DELETE",
  });
}
